import { TYPE_HYBRID } from "../constants";
import { participationTypes } from "../models";

export const getRegistrationFields = (event, $locale) => {
    const nameField = {
        label: $locale.get('auth.login.email.name'),
        type: 'text',
        name: 'name',
        required: true,
        placeholder: $locale.get('registration.placeholder.name'),
    };

    const nameCustomLabel = $locale.getProperty(event.moduleAuth, 'guestNicknamePlaceholder');
    if (nameCustomLabel) {
        nameField.label = nameCustomLabel;
        nameField.placeholder = null;
    }

    const fields = [nameField];

    if (event.participationType === TYPE_HYBRID) {
        fields.concat([{
            label: $locale.get('auth.login.participationType'),
            type: "select",
            name: "participationType",
            required: true,
            options: participationTypes($locale),
        }])
    }

    const eventRegistrationFields = event.registrationFields
        .map(({required, field}) => ({
            ...field,
            required,
            label: field['label_' + $locale.localeName],
            placeholder: field['placeholder_' + $locale.localeName],
            description: field['description_' + $locale.localeName],
            options: field.options.map((option) => ({
                ...option,
                label: option['label_' + $locale.localeName],
            })),
        })) || [];

    return fields.concat(eventRegistrationFields);
};
